import request from '@/utils/request'
const preFixUrl = '/report'
// 药品
/**
 * 列表
 * @param {*} data
 * @returns
 */
export const getList = data => {
  return request({
    url: `${preFixUrl}/drug/getList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 详情
 * @param {*} data
 * @returns
 */
export const getDetail = data => {
  return request({
    url: `${preFixUrl}/drug/getDetail`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

// 药品
/**
 * 列表
 * @param {*} data
 * @returns
 */
export const getList2 = data => {
  return request({
    url: `${preFixUrl}/drugV2/getList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 * 详情
 * @param {*} data
 * @returns
 */
export const getDetail2 = data => {
  return request({
    url: `${preFixUrl}/drugV2/getDetail`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}
